export default __webpack_public_path__ + "static/media/token-sales.5897a8cb.png";